import * as React from "react";
import { cn } from "@/shared/utils/utils";

type InputProps = React.ComponentProps<"input">;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", onChange, value, ...props }, ref) => {
    const isFile = type === "file";

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!onChange) return;

      let val: string | number | Date | null = e.target.value;

      switch (type) {
        case "number":
          val = val === "" ? "" : Number(val);
          break;
        case "date":
          val = val ? new Date(val) : null;
          break;
        case "file":
          return onChange(e);
        default:
          break;
      }

      onChange({
        ...e,
        target: {
          ...e.target,
          value: val,
        },
      } as React.ChangeEvent<HTMLInputElement>);
    };

    return (
      <input
        type={type}
        data-slot="input"
        ref={ref}
        onChange={handleChange}
        {...(!isFile ? { value: value ?? "" } : {})}
        className={cn(
          // Estilos base compartidos por todos los tipos de input
          "flex h-9 w-full min-w-0 rounded-xl px-3 pt-5 py-1 shadow-md/30 transition-[color,box-shadow] outline-none border border-gray-200",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",

          // Estados de foco y validación
          "focus-visible:border-focus-ring",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",

          // Estilos de selección de texto
          "selection:bg-primary selection:text-primary-foreground",

          // Estilos de placeholder
          "placeholder:text-muted-foreground",

          // Estilos específicos para input tipo file
          "file:text-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",

          // Estilos de texto
          "text-base md:text-sm",

          // Estilos específicos para input tipo text/password/email/etc
          type === "text" ||
            type === "password" ||
            type === "email" ||
            type === "number"
            ? [
                "bg-white h-10 text-black",
                // Aquí puedes agregar más estilos específicos para inputs de texto
              ]
            : [],

          // Clases personalizadas del usuario
          className
        )}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export { Input };
